import { createStore, useStore } from 'zustand'
import PointsApi from '../common/api'
import AccountApi from '@ssr/api/account'

const pageSize = 10

export const PageStore = createStore((set, get) => ({
  // 用户的积分
  totalPoints: 0,
  gerTotalPoint: () => {
    return AccountApi.getTotalPoints().then(({ data }) => {
      const { total_points } = data
      set({ totalPoints: total_points })
      return total_points
    })
  },

  // 项目列表
  productList: {
    processing: {
      list: [],
      loading: false,
      currentPageNumber: 0,
      totalPage: null,
    },
    next: {
      list: [],
      loading: false,
      currentPageNumber: 0,
      totalPage: null,
    },
    over: {
      list: [],
      loading: false,
      currentPageNumber: 0,
      totalPage: null,
    },
  },
  getProductList: async (status, isReload = false) => {
    const productList = get().productList
    const product = productList[status]
    if (!product) return false
    if (product.loading) return false
    if (!isReload && product.totalPage && product.currentPageNumber >= product.totalPage) return false

    const setProduct = (data) => {
      set((state) => {
        const productList = { ...state.productList }
        productList[status] = { ...productList[status], ...data }
        return { productList }
      })
    }

    const pageNumber = isReload ? 1 : product.currentPageNumber + 1
    setProduct({
      loading: true,
      currentPageNumber: pageNumber,
    })

    const res = await PointsApi.lotteryGetProductListV2({ lotteryStatus: status, pageNumber, pageSize })
    if (res?.data) {
      const { list, totalPage } = res.data
      const newList = isReload ? list : [...product.list, ...list]
      setProduct({ list: newList, totalPage, loading: false })
      return true
    }
    return false
  },

  // 用户参与的项目
  productListJoined: [],
  productListJoinedMap: new Map(),
  getProductListJoined: async () => {
    const res = await PointsApi.lotteryGetJoinedProductList()
    if (res?.data?.products) {
      const productListJoined = res.data.products
      const productListJoinedMap = new Map(productListJoined.map((e) => [e.id, e]))
      set({ productListJoined, productListJoinedMap })
      return true
    }
    return false
  },
}))

export default (selector) => useStore(PageStore, selector)
